import { render, staticRenderFns } from "./BookVideosSelector.vue?vue&type=template&id=10002107&scoped=true"
import script from "./BookVideosSelector.vue?vue&type=script&lang=js"
export * from "./BookVideosSelector.vue?vue&type=script&lang=js"
import style0 from "./BookVideosSelector.vue?vue&type=style&index=0&id=10002107&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10002107",
  null
  
)

export default component.exports